<template>
    <div>
      <v-card
        class="mt-6 mx-auto elevation-4 rounded-lg"
        max-width="1200"
      >
        <v-card-title class="page-head">
          <div class="ph-left">
            <div class="ph-icon"><v-icon color="#1565c0">mdi-file-chart</v-icon></div>
            <div>
              <div class="ph-title">Reports</div>
              <div class="ph-sub">Generate printable reports</div>
            </div>
          </div>
        </v-card-title>

        <v-card-text class="pa-5">
          <v-row>
            <v-col cols="12" sm="6" v-for="r in reportCards" :key="r.kind">
              <div class="report-card" @click="fetchReport(r.kind)">
                <div class="rc-icon" :style="{ background: r.bg }">
                  <v-icon :color="r.color">{{ r.icon }}</v-icon>
                </div>
                <div class="rc-text">
                  <div class="rc-title">{{ r.title }}</div>
                  <div class="rc-sub">{{ r.sub }}</div>
                </div>
                <v-icon color="#b8c4da">mdi-chevron-right</v-icon>
              </div>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
  <v-row justify="center">

<v-dialog
  v-model="dialog"
  persistent
  max-width="1100">
  <v-card class="elevation-8" style="border-radius: 14px; overflow: hidden;">
    <v-card-title class="dialog-header white--text px-4 py-3">
      <div class="d-flex align-center justify-space-between flex-grow-1">
        <div class="d-flex align-center">
          <v-avatar size="40" class="mr-3" color="white">
            <img src="../assets/realmow.png" alt="Logo" />
          </v-avatar>
          <div>
            <div class="subtitle-1 font-weight-medium">{{ title || 'Report' }}</div>
            <div class="caption dialog-subtitle">Ministry of women, Family Affairs &amp; Human Rights</div>
          </div>
        </div>
        <v-btn icon class="white--text" @click="closef">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </v-card-title>
    <v-divider></v-divider>

    <v-card-text class="mt-2">
      <div class="d-flex flex-wrap align-center mb-3 px-1">
        <v-btn class="primary mr-2 mb-2 print-btn" dark @click="print">
          <v-icon left small>mdi-printer</v-icon>
          Print
        </v-btn>
        <v-btn class="primary mr-2 mb-2 export-btn" dark @click="exportexcel">
          <v-icon left small>mdi-file-excel</v-icon>
          Export to Excel
        </v-btn>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          placeholder="Search..."
          dense
          outlined
          hide-details
          class="mb-2 report-search"
          prepend-inner-icon="mdi-magnify"
        />
      </div>
    
      <v-text-field v-model="search" placeholder="search">
      </v-text-field>
      <div id="print">
        <v-card>
        <div class="mt-2 text-center pa-3">
      
      <span style="text-align:center">
      <img src="../assets/realmow.png" width="400" height="280">
      </span>
      <div style="margin-top:4px;font-size:12px;color:#444;">{{ currentDate }}</div>
    </div>
    </v-card>
      <div class="caption grey--text mt-2">Total: {{ allfields.length }}</div>
      <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2"></v-progress-linear>
      <v-data-table
        style="text-align:center; border-radius: 10px; overflow: hidden;"
        :headers="headers"
        :items="allfields"
        :search="search"
        class="elevation-1 mt-2"
      >
      </v-data-table>
    </div>
    </v-card-text>

    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn
        color="green darken-1"
        text
        @click="closef"
      >Close</v-btn>
    </v-card-actions>
  </v-card>
</v-dialog>
</v-row>
 </div>
  </template>
  <script>
    import axios from 'axios';

    var url = process.env.VUE_APP_API_URL;

// Professional headers per report
const HEADERS = {
  children: [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'childname' },
    { text: 'Age', value: 'age' },
    { text: 'Sex', value: 'sex' },
    { text: 'Found Date', value: 'founddate' },
  ],
  mothers: [
    { text: 'ID', value: 'idga' },
    { text: 'Care Giver', value: 'mothername' },
    { text: 'Sex', value: 'sex' },
    { text: 'Contact', value: 'contact' },
    { text: 'Status', value: 'status' },
  ],
  nabadoon: [
    { text: 'ID', value: 'id' },
    { text: 'Name', value: 'name' },
    { text: 'Phone', value: 'phone' },
    { text: 'Address', value: 'address' },
    { text: 'Qabiil', value: 'qabiil' },
  ],
  assignments: [
    { text: 'ID', value: 'idga' },
    { text: 'Child', value: 'childname' },
    { text: 'Care Giver', value: 'mothername' },
    { text: 'Status', value: 'status' },
    { text: 'Description', value: 'description' },
  ],
}

// Endpoint config per report
const ENDPOINTS = {
  children:    { opcion: 10, op: 0, title: 'Children' },
  mothers:     { opcion: 11, op: 0, title: 'Care Givers' },
  nabadoon:    { opcion: 12, op: 0, title: 'Nabadoon' },
  assignments: { opcion: 13, op: 0, title: 'Assignments' },
}

  export default {
    name:'App',
    components :{
  
  },
    data () {
      return {
        search:'',
        title:'',
        tab: null,
        reportCards: [
          { kind: 'children',    title: 'Children',        sub: 'All registered children',        icon: 'mdi-human-child',           color: '#1565c0', bg: '#e3f0fd' },
          { kind: 'mothers',     title: 'Care Givers',     sub: 'All registered care givers',     icon: 'mdi-account-heart',         color: '#6a1b9a', bg: '#f3e5f5' },
          { kind: 'nabadoon',    title: 'Clan Elders',     sub: 'All registered clan elders',     icon: 'mdi-account-tie',           color: '#00695c', bg: '#e0f2f1' },
          { kind: 'assignments', title: 'Assignments',     sub: 'Child-care giver assignments',   icon: 'mdi-format-list-bulleted',  color: '#00838f', bg: '#e0f7fa' },
        ],
        allfields:[],
        dialog: false,
        opcion:'',
        loading: false,
        currentDate: new Date().toLocaleDateString(),
        authenticated:JSON.parse(localStorage.getItem('status'))
      }
    },
    mounted(){
      if(!this.authenticated){
        this.$router.replace({name:'login'});
      }
    },
    created(){
   
    },
    methods:{
      // Unified report fetcher
      fetchReport:function(kind){
        const cfg = ENDPOINTS[kind];
        if(!cfg) return;
        this.headers = HEADERS[kind];
        this.title = cfg.title;
        this.dialog = true;
        this.loading = true;
        const uid = (JSON.parse(localStorage.getItem('user') || '{}')).id || '';
        axios.post(url, { opcion: cfg.opcion, op: cfg.op, usr_id: uid, user_id: uid, assessedby: uid })
          .then(response => { this.allfields = response.data || []; })
          .catch(() => { this.allfields = []; })
          .finally(() => { this.loading = false; });
      },
      childrenReport:function(){ this.fetchReport('children'); },
      mothersReport:function(){ this.fetchReport('mothers'); },
      nabadoonReport:function(){ this.fetchReport('nabadoon'); },
      assignmentsReport:function(){ this.fetchReport('assignments'); },
      closef:function(){
        this.dialog=false;
        location.reload();
      },
     allchild:function(){
      this.headers.splice(5,50);
      this.op=1;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title='All Accounts'
      this.dialog=true;
     },
     allemployee:function(){
      this.headers.splice(11,50);
      this.headers.splice(1,4);
      this.op=2;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="All employee"
      this.dialog=true;
     },
     payroll:function(){
      this.headers.splice(17,50);
      this.headers.splice(1,10);
      this.op=3;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="Payroll"
      this.dialog=true;
     },
     donaters:function(){
      this.headers.splice(23,50);
      this.headers.splice(1,18);
      this.op=4;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="Donaters"
      this.dialog=true;
     },
     branche:function(){
      this.headers.splice(29,48);
      this.headers.splice(1,22);
      this.op=5;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="All Branches"
      this.dialog=true;
     },
     asset:function(){
      this.headers.splice(35,50);
      this.headers.splice(1,29);
      this.op=6;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="All Assets"
      this.dialog=true;
     },
     member:function(){
      this.headers.splice(41,50);
      this.headers.splice(1,34);
      this.op=7;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="All members"
      this.dialog=true;
     },
     income:function(){
      this.headers.splice(46,50);
      this.headers.splice(1,40);
      this.op=8;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="Income"
      this.dialog=true;
     },
     expayment:function(){
     // this.headers.splice(43,48);
      this.headers.splice(1,45);
      this.op=9;
              axios.post(url,{opcion:4,op:this.op, usr_id: (JSON.parse(localStorage.getItem('user') || '{}')).id || ''})
              .then(response =>{
                this.allfields = response.data;  
                console.log(this.allfields);                 
              });
      this.title="Expence payment"
      this.dialog=true;
     },
     
     print: function(){
      const prtHtml = document.getElementById('print').innerHTML;
        // Get all stylesheets HTML
        let stylesHtml = '';
        for (const node of [...document.querySelectorAll('link[rel="stylesheet"], style')]) {
          stylesHtml += node.outerHTML;
        }

        // Open the print window
        const WinPrint = window.open('', '', 'left=0,top=0,width=800,height=900,toolbar=0,scrollbars=0,status=0');

        WinPrint.document.write(`<!DOCTYPE html>
        <html>
          <head>
            ${stylesHtml}
          </head>
          <body>
            ${prtHtml}
          </body>
        </html>`);

        WinPrint.document.close();
        WinPrint.focus();
        WinPrint.print();
        WinPrint.close();

    },
  exportexcel: function(){
      var uri = 'data:application/vnd.ms-excel;base64,'
        , template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><meta http-equiv="content-type" content="text/plain; charset=UTF-8"/></head><body><table>{table}</table></body></html>'
        , base64 = function(s) { return window.btoa(unescape(encodeURIComponent(s))) }
        , format = function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
        var name="worksheet 1";
       var table = document.getElementById("print")
        var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
        window.location.href = uri + base64(format(template, ctx))

     }
    }
  }
</script>
<style scoped>
/* Report selector cards */
.report-card {
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 18px 20px;
  border: 1px solid #e6eaf2;
  border-radius: 14px;
  background: #fff;
  cursor: pointer;
  transition: box-shadow .2s ease, transform .15s ease, border-color .2s ease;
}
.report-card:hover {
  border-color: #b8c4da;
  box-shadow: 0 8px 22px rgba(22, 35, 63, .08);
  transform: translateY(-2px);
}
.rc-icon {
  width: 46px;
  height: 46px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.rc-text { flex: 1; }
.rc-title { font-size: .95rem; font-weight: 700; color: #26314a; }
.rc-sub { font-size: .76rem; color: #8a94a6; }

/* Dialog header */
.dialog-header {
  background: linear-gradient(135deg, #1565c0, #0d47a1) !important;
}
.dialog-subtitle { opacity: .8; }

/* Print/Export buttons */
.print-btn, .export-btn {
  display: flex;
  align-items: center;
  border-radius: 9px !important;
}
.print-btn .v-icon, .export-btn .v-icon {
  margin-right: 8px;
}
.report-search { max-width: 240px; }
</style>